import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface DocumentType {
  id: number;
  name: string;
  obligatory: boolean;
  fields: string[];
  maxDayToUpload?: number;
  createdAt: string;
  updateAt: string;
}

const initialState = {
  total: 0,
  documentTypes: [] as DocumentType[],
  page: 0,
  limit: 10,
  loading: true,
  search: "",
  sortBy: "id",
  defaultSort: "asc",
  fetchTrigger: 0,
};

const documentTypeSlice = createSlice({
  name: "documentType",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setDocumentTypes: (state, action: PayloadAction<DocumentType[]>) => {
      state.documentTypes = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.page = 0;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<string>) => {
      state.defaultSort = action.payload;
    },
    resetState: (state) => {
      Object.assign(state, initialState);
    },
    setFetch: (state) => {
      state.fetchTrigger += 1;
    },
  },
});

export const {
  setPage,
  setLimit,
  setDocumentTypes,
  setLoading,
  setTotal,
  setSearch,
  setSortBy,
  setDefaultSort,
  resetState,
  setFetch,
} = documentTypeSlice.actions;

export default documentTypeSlice.reducer;
